import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { useUploadChatFileMutation } from '../../../../store/chatbox/chatboxApi';
import { base64ToFile, blobToFile } from '../../../../utils/base64AndBlobToFile';
import Loading from '../../../../shared/Loading';

const WebcamCapture = ({
	onClose,
	setAddFile
}: {
	onClose: () => void,
	setAddFile: (file: {
		name: string;
		url: string;
	}[]) => void
}) => {
  const [chatboxFile, {isLoading}] = useUploadChatFileMutation();
  const webcamRef = useRef<Webcam>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);

  const [recording, setRecording] = useState<boolean>(false);

  const capturePhoto =  async () => {
    if (webcamRef.current) {
      const screenshot = webcamRef.current.getScreenshot() || '';
	  const imageFile = base64ToFile(screenshot, 'photo.jpg');
      if (screenshot) {
		try {
			const formData = new FormData();
	 		formData.append('files', imageFile);
			 const newFile = await chatboxFile(formData).unwrap()
			 setAddFile(newFile);
			onClose()
		  } catch (e) {
		  }
      }
	  
    }
  };

  const startRecording = () => {
	const stream = webcamRef.current?.stream;
  
	if (!stream) {
	  console.error('Webcam stream not available');
	  return;
	}
  
	const localChunks: Blob[] = []; // ← use local variable
  
	const mediaRecorder = new MediaRecorder(stream, {
	  mimeType: 'video/webm',
	});
  
	mediaRecorderRef.current = mediaRecorder;
  
	mediaRecorder.ondataavailable = (event: BlobEvent) => {
	  if (event.data && event.data.size > 0) {
		localChunks.push(event.data); // ← store locally
	  }
	};
  
	mediaRecorder.onstop = async () => {
	  const blob = new Blob(localChunks, { type: 'video/webm' });
	  const file = blobToFile(blob, 'recording.webm');
	  const formData = new FormData();
	  formData.append('files', file);
	  try {
		const newFile = await chatboxFile(formData).unwrap()
		setAddFile(newFile);
		onClose()
	  } catch (e) {
	  }
	};
  
	mediaRecorder.start();
	setRecording(true);
  };
  

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setRecording(false);
    }
  };

  return (
    <div>
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width={1280}
        height={479}
        videoConstraints={{
          width: 386,
          height: 467,
          facingMode: 'environment',
          frameRate: 30,
        }}
        imageSmoothing={true}
        screenshotQuality={1}
      />

	  {isLoading ? <div className='flex flex-row items-center justify-center w-full mt-2'>
	  	<Loading />
	  </div> : 
	  <div className='mt-2 w-full flex justify-center'>
		<button onClick={capturePhoto} type="button">📸 Take Photo</button>
			{!recording ? (
				<button onClick={startRecording} className='ml-3' type="button">🎥 Start Recording</button>
			) : (
				<button onClick={stopRecording} type="button">⏹️ Stop Recording</button>
			)}
		</div>
	  }
    </div>
  );
};

export default WebcamCapture;
